var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animate-route"},[_c('details-info',{attrs:{"title":_vm.productInfo.name,"describe":"","htmlStr":_vm.productInfo.content}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }